import React, { Component } from 'react';
import PropTypes from 'prop-types';

class XInput extends Component{

    constructor(props) {
        super(props)
        this.props=props;
    }

    render(){
        const {
            type,
            className,
            value,
            id,
            style: styleProps,
            eleRef,
            onChange,
            onClick,
            onDoubleClick,
            onFocus,
            onKeyUp,onKeyPress,onBlur,
            readonly,spellCheck,
        } = this.props;

        let isReadonly;
        if(readonly) isReadonly='readonly';

        let style = {
            //textDecoration:'none',
        };
        style = Object.assign({}, style, styleProps || {});
        return(
            <input ref={eleRef} className={className} id={id} style={style} onChange={onChange}
                   onFocus={onFocus}   onKeyUp={onKeyUp} onKeyPress={onKeyPress}
              readOnly={isReadonly}  spellCheck={spellCheck} value={value}  onClick={onClick}
                   onDoubleClick={onDoubleClick}  type={type} onBlur={onBlur} />
        )
    }

}


XInput.propTypes = {
    type: PropTypes.oneOf(['button', 'checkbox', 'color', 'date', 'datetime-local','email'
        ,'file','hidden','image','month','number','password','radio','range','reset','search','submit'
        ,'tel','text','time','url','week','datetime']),
    className: PropTypes.string,
    value: PropTypes.string,
    id: PropTypes.string,
    eleRef: PropTypes.any,
    onChange: PropTypes.func,
    onClick: PropTypes.func,
    onDoubleClick: PropTypes.func,
    onKeyUp: PropTypes.func,
    onKeyPress: PropTypes.func,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func,
    readonly: PropTypes.bool,
    spellCheck: PropTypes.bool,
};

XInput.defaultProps = {};

export default  XInput;

